import React, { useState } from 'react';
import { BsXCircle } from 'react-icons/bs';
import { Button } from 'react-bootstrap';

import { ImageFile, useImageClipboard } from '../../hooks/imageClipboard';

const ImageListClipboard: React.FC<{ imageFile: ImageFile[] }> = ({
  imageFile,
}) => {
  const { removeImage } = useImageClipboard();
  return (
    <div className="d-flex border border-1 border-secondary rounded-2 p-2  ">
      {imageFile.map((img: ImageFile) => {
        return (
          <div className="d-flex" key={img.key}>
            <img
              style={{ height: '5rem', width: '5rem' }}
              className="me-2 pt-0"
              src={URL.createObjectURL(img.File)}
              alt="Imagem Clipboard"
            />
            <div>
              <Button
                className="bg-transparent border-0 shadow-none p-0 me-2"
                onClick={() => removeImage(img.key)}
              >
                <BsXCircle size={16} className="text-black" />
              </Button>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ImageListClipboard;
